import {
  ErrorHandlerPublicAPI,
  ResolvedError,
} from '@wix/yoshi-flow-editor/build/cjs/exports/error-handler'

interface WixHttpError {
  isWixHttpError: boolean
  requestId: string
  response: {
    data?: {
      message?: string
      details: {
        applicationError: {
          code?: string
        }
      }
    }
    status: number
  }
}

export type ClientWithErrorHandler = ErrorHandlerPublicAPI['withErrorHandler']

export const isWixHttpError = (err: any): err is WixHttpError => err?.isWixHttpError

export const isResolvedError = (error): error is ResolvedError => {
  return 'applicationError' in error
}

export const isCaptchaError = (error: any): boolean => {
  return (
    error?.applicationError?.code === 'CAPTCHA_REQUIRED' ||
    error?.applicationError?.code === 'CAPTCHA_INVALID'
  )
}
